import { Button, Input, Modal } from "antd";
import { useEffect, useState } from "react";
import DaumPostcodeEmbed from "react-daum-postcode";

declare global {
    interface Window {
        kakao: {
            maps: {
                LatLng: new (lat: number, lng: number) => any;
                Map: new (container: HTMLElement, options: any) => any;
                Marker: new (options: any) => any;
                services: {
                    Geocoder: new () => {
                        addressSearch(
                            address: string,
                            callback: (
                                result: { x: string; y: string; address_name: string }[],
                                status: string
                            ) => void
                        ): void;
                    };
                    Status: {
                        OK: string;
                    };
                };
            };
        };
    }
}


interface IProps {
    onChange?: (data: IRoadNameAddress) => void;
    roadNameAddress?: { address: string, lat: number, lon: number }
}


const RoadNameAddress = ({ onChange, roadNameAddress = { address: '', lat: 0, lon: 0 } }: IProps) => {
    const [isDaumPostcodeModal, setIsDaumPostcodeModal] = useState(false);
    const [keyy, setKey] = useState(0);
    const [data, setData] = useState<{ address: any; lat: number; lon: number; }>();
    const loadKakaoMapScript = () => {
        return new Promise<void>((resolve, reject) => {
            if (window.kakao && window.kakao.maps) {
                resolve();
                return;
            }

            const script = document.createElement('script');
            script.src = '//dapi.kakao.com/v2/maps/sdk.js?appkey=9ffa85eb01e63802e996843458975b60&libraries=services';
            script.async = true;
            script.onload = () => {
                if (window.kakao && window.kakao.maps) {
                    resolve();
                } else {
                    reject(new Error('Kakao Maps SDK failed to load'));
                }
            };
            script.onerror = (e) => reject(new Error('Failed to load Kakao SDK ' + e));
            document.head.appendChild(script);
        });
    };

    useEffect(() => {
        loadKakaoMapScript()
            .then(() => {
                console.log('Kakao Maps SDK loaded successfully');
            })
            .catch(err => {
                console.error('Error loading Kakao Maps SDK:', err);
            });
    }, []);

    const handleComplete = (data: any) => {
        let fullAddress = data.address;
        let extraAddress = '';
        if (data.addressType === 'R') {
            if (data.bname !== '') extraAddress += data.bname;
            if (data.buildingName !== '') extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            fullAddress += extraAddress ? ` (${extraAddress})` : '';
        }

        setKey(q => q + 1);
        setIsDaumPostcodeModal(false);

        if (window.kakao && window.kakao.maps) {
            const geocoder = new window.kakao.maps.services.Geocoder();
            geocoder.addressSearch(fullAddress, (result, status) => {
                if (status === window.kakao.maps.services.Status.OK) {
                    const lon = parseFloat(result[0].y);
                    const lat = parseFloat(result[0].x);

                    const value = { address: fullAddress, lat, lon };
                    setData(value);
                    onChange?.(value);
                } else {
                    const value = { address: fullAddress, lat: 0, lon: 0 };
                    setData(value);
                    onChange?.(value);
                }
            });
        }
    };

    return <>
        <div style={{ display: 'flex', gap: '16px' }}>
            <Input
                placeholder="주소 검색"
                value={roadNameAddress.address}
                maxLength={250}
                onChange={e => { onChange?.({ address: e.target.value, lat: data?.lat ?? 0, lon: data?.lon ?? 0 }) }}
            />
            <Button type="primary" onClick={() => setIsDaumPostcodeModal(true)}>
                검색
            </Button>
            <Modal
                title="우편번호 검색"
                open={isDaumPostcodeModal}
                onCancel={() => setIsDaumPostcodeModal(false)}
                footer={null}
            >
                <DaumPostcodeEmbed key={keyy} onComplete={handleComplete} />
            </Modal>
        </div>
    </>
};

export { RoadNameAddress }